import BaseController from './basePlayerController';
import { OP_WRAPPER_LOCALIZATION_PREFIX } from '../../../utils/constants';
import { format } from '../../../utils/formatCurrency';

export default class ControllerFreebetsPanel extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eElementsTypes = {
      EET_COUNT_LEFT_LABEL: 'count_left_label',
      EET_COUNT_LEFT_VALUE: 'count_left_value',
      EET_TOTAL_COUNT_LABEL: 'total_count_label',
      EET_TOTAL_COUNT_VALUE: 'total_count_value',
      EET_BET_LABEL: 'bet_label',
      EET_BET_VALUE: 'bet_value',
      EET_TOTAL_WIN_LABEL: 'total_win_label',
      EET_TOTAL_WIN_VALUE: 'total_win_value',
    };
    this._localizations = {
      [this._eElementsTypes.EET_COUNT_LEFT_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.freeBets.bottomBar.betsCountLeftText`,
      [this._eElementsTypes.EET_TOTAL_COUNT_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.freeBets.bottomBar.betsCountMidleText`,
      [this._eElementsTypes.EET_BET_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.freeBets.bottomBar.bet`,
      [this._eElementsTypes.EET_TOTAL_WIN_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.freeBets.bottomBar.totalWin`,
    };
    // this._adaptiveElements = [this._eElementsTypes.EET_LABEL, this._eElementsTypes.EET_VALUE];

    this.init(container);
  }

  _afterInit() {
    super._afterInit();
    this.update(window.OPWrapperService.freeBetsController.displayData);
    console.log('freebets enabled: ', window.OPWrapperService.freeBetsController.enabled)
    if (!window.OPWrapperService.freeBetsController.enabled) this.hide();
  }

  update(data) {
    this.data = data;
    this.set(this._eElementsTypes.EET_TOTAL_COUNT_VALUE, data.freeBetsQuantity);
    this.setBet(data);
    this.setFreeBets(data.freeBets);
    this.setTotalWin(data.totalWin);
  }

  setBet(data) {
    this.data = data;
    this.set(this._eElementsTypes.EET_BET_VALUE, this._moneyFormat(data.bet));
  }

  setFreeBets(value) {
    this.set(this._eElementsTypes.EET_COUNT_LEFT_VALUE, value);
  }

  setTotalWin(value) {
    this.set(this._eElementsTypes.EET_TOTAL_WIN_VALUE, this._moneyFormat(value));
  }

  _moneyFormat(value) {
    return `${format(value, this.data.decimals, this.data.decimals > 2)} ${this.data.currency.toUpperCase()}`
  }

  _getMarkup() {
    return `
      <div class="freeBetsBottomBar__container">
        <div class="freeBetsBottomBar__betsCount freeBetsBottomBar__item">
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_COUNT_LEFT_LABEL]} class="freeBetsBottomBar__betsCountLeftText">${this._getLocalization(this._localizations[this._eElementsTypes.EET_COUNT_LEFT_LABEL])}</span>
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_COUNT_LEFT_VALUE]} class="freeBetsBottomBar__currentBetsAmount">1</span>
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TOTAL_COUNT_LABEL]} class="freeBetsBottomBar__betsCountMidleText">${this._getLocalization(this._localizations[this._eElementsTypes.EET_TOTAL_COUNT_LABEL])}</span>
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TOTAL_COUNT_VALUE]} class="freeBetsBottomBar__betsCountTotalBetsAmount">20</span>
        </div>
        <div class="freeBetsBottomBar__bet freeBetsBottomBar__item">
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_BET_LABEL]} class="freeBetsBottomBar__betText">${this._getLocalization(this._localizations[this._eElementsTypes.EET_BET_LABEL])}</span>
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_BET_VALUE]} class="freeBetsBottomBar__betAmount">5 usd</span>
        </div>
        <div class="freeBetsBottomBar__totalWin freeBetsBottomBar__item">
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TOTAL_WIN_LABEL]} class="freeBetsBottomBar__totalWinText">${this._getLocalization(this._localizations[this._eElementsTypes.EET_TOTAL_WIN_LABEL])}</span>
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TOTAL_WIN_VALUE]} class="freeBetsBottomBar__totalWinAmount">0 usd</span>
        </div>
      </div>`
  }
}
